import { authHttpClient } from './client'
import { AxiosResponse } from 'axios'
import { Residency } from '../models/Residency'

type LoginResponse = {
  access_token: string
  refresh_token: string
  challengeName: string
  session: any
}

export const loginWithUsernamePasswordConsoleV2 = (
  email: string,
  password: string,
  stayLoggedIn: boolean,
  captchaToken: string,
): Promise<AxiosResponse<LoginResponse>> => {
  return authHttpClient.postForm(`/v2/console/login`, {
    email,
    password,
    stayLoggedIn,
    captchaToken,
  })
}

type RefreshTokenResponse = {
  access_token: string
  refresh_token: string
}

export const refreshTokenRequest = (accountId: string, refreshToken: string): Promise<AxiosResponse<RefreshTokenResponse>> => {
  return authHttpClient.post(`/v1/accounts/${accountId}/token/refresh`, null, { headers: { Authorization: `Bearer ${refreshToken}` } })
}

export const getConsoleTokenForAssociationCode = (code: string, stayLoggedIn: boolean): Promise<AxiosResponse<LoginResponse>> => {
  return authHttpClient.postForm(`/v2/console/oauth2/token`, {
    code,
    stayLoggedIn,
  })
}

export const signUpWithUsernamePasswordConsoleV2 = (
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  captchaToken: string,
  state: string | null,
  residency: Residency,
): Promise<AxiosResponse> => {
  return authHttpClient.postForm('/v2/console/signup', {
    firstName,
    lastName,
    email,
    password,
    captchaToken,
    ...(state && { state }),
    residency,
  })
}

export const confirmSignUpWithVerificationCodeConsole = (email: string, code: string): Promise<AxiosResponse<LoginResponse>> => {
  return authHttpClient.postForm('/v2/console/confirm-signup', {
    email,
    code,
  })
}

export const forgotPassword = (email: string): Promise<AxiosResponse> => {
  return authHttpClient.postForm('/v2/console/forgot-password', {
    email,
  })
}

export const confirmForgotPassword = (email: string, password: string, code: string): Promise<AxiosResponse> => {
  return authHttpClient.postForm('/v2/console/confirm-forgot-password', {
    email,
    password,
    code,
  })
}

export interface InviteContext {
  accountName: string
  inviterName?: string
  firstName?: string
  lastName?: string
  email?: string
}

export const getInviteContext = (code: string): Promise<InviteContext> => {
  return authHttpClient.get<InviteContext, InviteContext>(`/v2/console/invitation/${encodeURIComponent(code)}`)
}

export const resendVerification = (email: string): Promise<void> => {
  return authHttpClient.postForm<void, void>('/v2/console/resend-verification', {
    email,
  })
}
